//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The type of filter that should be applied to group members when sourcing scheduler resources. */
export const SchedulerResourceGroupMemberFilterType = {
    /** Show group members whose scheduling preferences match the schedule and location. */
    ShowMatchingPreference: 0,

    /** Show all group members. */
    ShowAllGroupMembers: 1
} as const;

/** The type of filter that should be applied to group members when sourcing scheduler resources. */
export const SchedulerResourceGroupMemberFilterTypeDescription: Record<number, string> = {
    0: "Show Matching Preference",

    1: "Show All Group Members"
};

/** The type of filter that should be applied to group members when sourcing scheduler resources. */
export type SchedulerResourceGroupMemberFilterType = typeof SchedulerResourceGroupMemberFilterType[keyof typeof SchedulerResourceGroupMemberFilterType];
